import { Component, OnDestroy, ViewChild, AfterViewInit } from '@angular/core';
import { BuildHealthReportComponent } from './build-health-report/build-health-report.component';
import { DateHelpers } from '../utilities/DateHelpers';
import { Choice } from 'src/app/pick-one/pick-one.component';
import { Subscription } from 'rxjs';
import { CountdownService } from '../services/countdown.service';

@Component({
  selector: 'app-build-health',
  templateUrl: './build-health.component.html',
  styleUrls: ['./build-health.component.css']
})
export class BuildHealthComponent implements OnDestroy, AfterViewInit {

  @ViewChild(BuildHealthReportComponent) report: BuildHealthReportComponent;

  public numberOfBuildsChoices: Choice[] = [
    new Choice('10', '10 builds per definition'),
    new Choice('15', '15 builds per definition'),
    new Choice('20', '20 builds per definition'),
    new Choice('25', '25 builds per definition'),
  ];

  public buildsToViewChoices: Choice[] = [
    new Choice('today', 'since midnight'),
    new Choice('1days', 'in the last 24 hours'),
    new Choice('2days', 'in the last 48 hours')
  ];

  private dateHelpers = new DateHelpers()
  private numberOfBuilds: string;
  private buildsToView: string;

  private loading: boolean = true;
  private count: number = 60;
  private subscription: Subscription;

  constructor(private countdownService: CountdownService) { }

  ngAfterViewInit(): void {
    if (this.readyToViewReport()) {
      this.load();
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  public readyToViewReport(): boolean {
    return this.numberOfBuilds.length > 0 && this.buildsToView.length > 0;
  }

  public pickNumberOfBuildsChoice(choice: string) {
    if (this.numberOfBuilds !== choice) {
      this.numberOfBuilds = choice;
      this.report.clearReport();
    }
  }

  public pickBuildsToViewChoice(choice: string) {
    if (this.buildsToView !== choice) {
      this.buildsToView = choice;
      this.report.clearReport();
    }
  }
  
  public onReportIsLoaded(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.subscription =  this.countdownService.start('build-health-update', 60).subscribe(counter => {
      this.count = counter;
      if (counter === 0) {
        this.load();
      }
    });
    this.loading = false;
  }
 
  public reportButtonText(): string {
    if (this.loading) { 
      return 'Loading...';
    }
    if (this.count > 0) {
      return `Load Data - ${this.count}`;
    }
    return 'Load Data';
  }

  public load(): void {
    this.loading = true;
    this.report.loadReport(Number(this.numberOfBuilds), this.getMinimumDate(), this.getMaximumDate());
  }

  private getMinimumDate(): Date {
    const now = new Date();
    switch (this.buildsToView) {
        case 'today':
            return this.dateHelpers.atBeginningOfDay(now);
        case '6hrs':
            return this.dateHelpers.addHours(now, -6);
        case '12hrs':
            return this.dateHelpers.addHours(now, -12);
        case '1day':
            return this.dateHelpers.addDays(now, -1);
        case '2days':
            return this.dateHelpers.addDays(now, -2);
        case '7days':
            return this.dateHelpers.addDays(now, -7);
        default:
            return this.dateHelpers.atBeginningOfDay(now);
      }
  }

  private getMaximumDate(): Date {
    return this.dateHelpers.atEndOfDay(new Date());
  }
}